export default __webpack_public_path__ + "static/media/Risorsa.a65eea4e.svg";